import React from 'react'
import styled from 'styled-components'

import { Button } from 'components/atoms'

export const FilterContainer = styled.div`
  div[class^='label'] {
    font-stretch: normal;
    font-style: normal;
    letter-spacing: normal;
    color: ${ (props) => props.theme.colors['standard-schwarz'] };
  }

  .splitted-group {
    margin-top: 32px;

    .label {
      font-size: 18px;
      font-weight: normal;
      line-height: normal;
    }

    .splitted-group-filters {
      margin-top: 16px;
      .label {
        font-weight: 300;
      }
    }
  }

  .label-mobile {
    font-size: 17px;
    font-weight: bold;
    line-height: 1.47;
    margin-bottom: 9px;
  }
`

export const LoadMoreButton = styled((props) => <Button { ...props } />)`
  margin: 19px auto 0;
`
